import React, { useState, useEffect } from "react";

// Style
import "./LevelUno.scss";

// Assets
import Arrow from "../../../src/assets/images/level-dos/arrow.svg";
import Uno from "../../../src/assets/images/home/Uno.svg";
import InnerRectangle from "../../../src/assets/images/home/InnerRectangle.svg";
import OuterRectangle from "../../../src/assets/images/home/OuterRectangle.svg";

// Functions
import { getRotationAngle } from "../../utils/randomNums";
import Navbar from "../../components/common/Navbar";
import LevelComplete from "../../components/common/LevelComplete/LevelComplete";

// Const
const ERR_MARGIN = 0.1;

function LevelUno() {
  const [translate, setTranslate] = useState([
    { x: 0, y: 0 },
    { x: 0, y: 0 },
    { x: 0, y: 0 },
    { x: 0, y: 0 },
  ]);
  const [won, setWon] = useState(false);
  const [move, setMove] = useState(false);

  const [timeTaken, setTimeTaken] = useState({
    firstClick: 0,
    firstArrorDone: 0,
    beforeHint: 0,
    totalTime: 0,
  });

  // counter
  const [clicksTaken, setClicksTaken] = useState({
    firstArrow: 0, // first arrow done
    secondArrow: 0, // second arrow done
    thirdArrow: 0, // third arrow done
    fourthArrow: 0, // fourth arrow done
    numOfHints: 0, // number of hints
    firstHint: 0, // clicks for first hint
    getsGame: false, // solves without hints
    total: 0, //total clicks
  });

  // For API
  const [finalClicksTaken, setFinalClicksTaken] = useState({
    firstArrow: false, // first arrow done
    secondArrow: false, // second arrow done
    thirdArrow: false, // third arrow done
    fourthArrow: false, // fourth arrow done
    numOfHints: false, // number of hints
    firstHint: false, // clicks for first hint
    getsGame: false, // solves without hints
    total: false, //total clicks
  });

  // Check for win condition
  useEffect(() => {
    let positions = [];
    let valid = true;
    let div = document.querySelector(".first-arrow");
    positions.push({
      x: div.getBoundingClientRect().x,
      y: div.getBoundingClientRect().y,
    });
    div = document.querySelector(".second-arrow");
    positions.push({
      x: div.getBoundingClientRect().x,
      y: div.getBoundingClientRect().y,
    });
    div = document.querySelector(".third-arrow");
    positions.push({
      x: div.getBoundingClientRect().x,
      y: div.getBoundingClientRect().y,
    });
    div = document.querySelector(".fourth-arrow");
    positions.push({
      x: div.getBoundingClientRect().x,
      y: div.getBoundingClientRect().y,
    });
    console.log({ positions });
    positions.forEach((item) => {
      if (
        item.x > window.innerWidth * ERR_MARGIN &&
        item.x < window.innerWidth - window.innerWidth * ERR_MARGIN &&
        item.y > window.innerHeight * ERR_MARGIN &&
        item.y < window.innerHeight - window.innerHeight * ERR_MARGIN
      ) {
        valid = false;
      }
    });

    // Clicks for first arrow
    if (
      !(
        positions[0].x > window.innerWidth * ERR_MARGIN &&
        positions[0].x < window.innerWidth - window.innerWidth * ERR_MARGIN &&
        positions[0].y > window.innerHeight * (ERR_MARGIN + 0.1) &&
        positions[0].y < window.innerHeight - window.innerHeight * ERR_MARGIN &&
        finalClicksTaken.firstArrow === false
      )
    ) {
      setFinalClicksTaken({
        ...finalClicksTaken,
        ...{ firstArrow: clicksTaken.firstArrow },
      });
    }

    // Clicks for second arrow
    if (
      !(
        positions[1].x > window.innerWidth * ERR_MARGIN &&
        positions[1].x < window.innerWidth - window.innerWidth * ERR_MARGIN &&
        positions[1].y > window.innerHeight * ERR_MARGIN &&
        positions[1].y < window.innerHeight - window.innerHeight * ERR_MARGIN &&
        finalClicksTaken.secondArrow === false
      )
    ) {
      setFinalClicksTaken({
        ...finalClicksTaken,
        ...{ secondArrow: clicksTaken.secondArrow },
      });
    }

    // Clicks for third arrow
    if (
      !(
        positions[2].x > window.innerWidth * ERR_MARGIN &&
        positions[2].x < window.innerWidth - window.innerWidth * ERR_MARGIN &&
        positions[2].y > window.innerHeight * (ERR_MARGIN + 0.5) &&
        positions[2].y < window.innerHeight - window.innerHeight * ERR_MARGIN &&
        finalClicksTaken.thirdArrow === false
      )
    ) {
      setFinalClicksTaken({
        ...finalClicksTaken,
        ...{ thirdArrow: clicksTaken.thirdArrow },
      });
    }

    // Clicks for fourth arrow
    if (
      !(
        positions[3].x > window.innerWidth * ERR_MARGIN &&
        positions[3].x < window.innerWidth - window.innerWidth * ERR_MARGIN &&
        positions[3].y > window.innerHeight * ERR_MARGIN &&
        positions[3].y < window.innerHeight - window.innerHeight * ERR_MARGIN &&
        finalClicksTaken.fourthArrow === false
      )
    ) {
      setFinalClicksTaken({
        ...finalClicksTaken,
        ...{ fourthArrow: clicksTaken.fourthArrow },
      });
    }

    if (valid) setWon(true);
  }, [translate]);

  // Call won state
  useEffect(() => {
    setTimeout(() => {
      if (won) {
        setMove(true)
      }
    }, 500);
  }, [won]);

  const translateArrow = (num) => {
    let tempClicks = {
      firstArrow: clicksTaken.firstArrow + 1,
      secondArrow: clicksTaken.secondArrow + 1,
      thirdArrow: clicksTaken.thirdArrow + 1,
      fourthArrow: clicksTaken.fourthArrow + 1,
      numOfHints: clicksTaken.numOfHints + 1,
      firstHint: clicksTaken.firstHint + 1,
      total: clicksTaken.total + 1,
    };
    setClicksTaken({ ...clicksTaken, ...tempClicks });

    let angle = 0;
    let elem = null;
    switch (num) {
      case 1:
        elem = document.querySelector(".first-arrow");
        angle = getRotationAngle(elem);
        break;
      case 2:
        elem = document.querySelector(".second-arrow");
        angle = getRotationAngle(elem);
        break;
      case 3:
        elem = document.querySelector(".third-arrow");
        angle = getRotationAngle(elem);
        break;
      case 4:
        elem = document.querySelector(".fourth-arrow");
        angle = getRotationAngle(elem);
        break;
      default:
        break;
    }

    let tempTranslate = [...translate];

    if (angle > 0 && angle < 90) {
      tempTranslate[num - 1].x = tempTranslate[num - 1].x - 3;
      tempTranslate[num - 1].y = tempTranslate[num - 1].y + 3;
    }
    if (angle > 90 && angle < 180) {
      tempTranslate[num - 1].x = tempTranslate[num - 1].x - 3;
      tempTranslate[num - 1].y = tempTranslate[num - 1].y - 3;
    }
    if (angle > 180 && angle < 270) {
      tempTranslate[num - 1].x = tempTranslate[num - 1].x + 3;
      tempTranslate[num - 1].y = tempTranslate[num - 1].y - 3;
    }
    if (angle > 270 && angle < 360) {
      tempTranslate[num - 1].x = tempTranslate[num - 1].x + 3;
      tempTranslate[num - 1].y = tempTranslate[num - 1].y + 3;
    }

    setTranslate(tempTranslate);
  };

  return (
    <div className="level-uno">
      {move && <LevelComplete levelNum={1} />}
      <Navbar won={won} levelNum={1}/>
      <div className="main-picture-wrapper">
        <div
          className="arrows first-arrow-div"
          style={{
            transform: `translate(${translate[0].x}cm,${translate[0].y}cm)`,
          }}
        >
          <img
            className="first-arrow"
            onClick={() => translateArrow(1)}
            src={Arrow}
            alt="arrow"
          />
        </div>
        <div
          className="arrows second-arrow-div"
          style={{
            transform: `translate(${translate[1].x}cm,${translate[1].y}cm)`,
          }}
        >
          <img
            className="second-arrow"
            onClick={() => translateArrow(2)}
            src={Arrow}
            alt="arrow"
          />
        </div>
        <div
          className="arrows third-arrow-div"
          style={{
            transform: `translate(${translate[2].x}cm,${translate[2].y}cm)`,
          }}
        >
          <img
            className="third-arrow"
            onClick={() => translateArrow(3)}
            src={Arrow}
            alt="arrow"
          />
        </div>
        <div
          className="arrows fourth-arrow-dov"
          style={{
            transform: `translate(${translate[3].x}cm,${translate[3].y}cm)`,
          }}
        >
          <img
            className="fourth-arrow"
            onClick={() => translateArrow(4)}
            src={Arrow}
            alt="arrow"
          />
        </div>
        <div className="main-picture">
          <img className="uno" src={Uno} alt="uno" />
          <img className="inner" src={InnerRectangle} alt="box" />
          <img className="outer" src={OuterRectangle} alt="box-inside" />
        </div>
      </div>
    </div>
  );
}

export default LevelUno;
